import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminNavBarMain from "./AdminNavBarMain";
import Cookies from 'js-cookie';
const AdminDashboard = (props) => {
  const navigate = useNavigate();
  Cookies.set("is_first_tab", true, { expires: 7 });
  Cookies.set("is_business_first_tab", true, { expires: 7 });
  function disableBackButton() {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", function (event) {
      window.history.pushState(null, null, window.location.pathname);
    });
  }

  useEffect(() => {
    disableBackButton();

    if (!Cookies.get("User_Accesstoken_Admin")) {
      navigate("/adminlogin");
    }
  }, []);
  const handleServiceRequests = () => {
    navigate("/allservicerequests");
  };
  const handleDocRepo = () => {
    navigate("/documentrepository");
  };
  const handleCompliance = () => {
    navigate("/compliance");
  };

  const handleEkyc = () => {
    navigate("/ekyc");
  };

  const handleInvestors = () => {
    navigate("/admininvestors");
  };

  const handleBusiness = () => {
    navigate("/listofbusinesses");
  };
  const handleSettings = () => {
    navigate("/adminsettings");
  };

  const [showNotif, setShowNotif] = useState(false);
  const handleCloseNotif = () => setShowNotif(false);

  return (
    <div>
      <AdminNavBarMain />

      {/* <div className="container">
        <div className="d-flex justify-content-evenly">
          <div className="">
            <div className="card admin-cards " onClick={handleBusiness}>
              <div className="card-body text-center ">
                <img
                  className="img-fluid "
                  src="./images/business_logo.svg"
                  alt="true"
                />
                <h4 className="mt-2">Business</h4>
                <div className="card_paragraph">
                  Business refers to an enterprising entity or organization that
                  carries out professional activities.
                </div>
              </div>
            </div>
          </div>
          <div className="">
            <div className="card admin-cards" onClick={handleInvestors}>
              <div className="card-body text-center ">
                <img
                  className="img-fluid "
                  src="./images/Investors.svg"
                  alt="true"
                />
                <h4 className="mt-2">Investors</h4>
                <div className="card_paragraph">
                  Investor is an individual that puts money into an entity such
                  as a business for a financial return.
                </div>
              </div>
            </div>
          </div>
          <div className="" onClick={handleServiceRequests}>
            <div className="card admin-cards">
              <div className="card-body text-center ">
                <img
                  className="img-fluid "
                  src="./images/service request_1.svg"
                  alt="true"
                />
                <h4 className="mt-2">Service Request</h4>
                <div className="card_paragraph ">
                  Service request defined as a formal request for service from
                  an employee, customer, or vendor.{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-2 d-flex justify-content-evenly ms-5 ps-5">
          <div className="" onClick={handleDocRepo}>
            <div className="card admin-cards">
              <div className="card-body text-center ">
                <img
                  className="img-fluid "
                  src="./images/documents.svg"
                  alt="true"
                />
                <h4 className="mt-2">Documents Repository</h4>
                <div className="card_paragraph">
                  A document repository is used to keep a business documents
                  securely stored and organised in a centralised location.{" "}
                </div>
              </div>
            </div>
          </div>
          <div className="" onClick={handleCompliance}>
            <div className="card admin-cards">
              <div className="card-body text-center">
                <img
                  className="img-fluid "
                  src="./images/complience.svg"
                  alt="true"
                />
                <h4 className="mt-2">Compliance</h4>
                <div className="card_paragraph">
                  Compliance means that a company adheres to the applicable
                  rules and laws. This includes both country specific laws and
                  requirements.
                </div>
              </div>
            </div>
          </div>

          <div className="" onClick={handleEkyc}>
            <div className="card admin-cards">
              <div className="card-body text-center">
                <img
                  className="img-fluid-ekyc "
                  src="./images/ekyc.jpg"
                  alt="true"
                />
                <h4 className="mt-2">eKYC</h4>
                <div className="card_paragraph">
                 Electronic Know Your Customer - verify investor
                  identities through document capture,biometrics and risk assessment.
                </div>
              </div>
            </div>
          </div>
          <div className="" onClick={handleSettings}>
            <div className="card admin-cards">
              <div className="card-body text-center">
                <i className="fa-solid fa-gear" style={{ fontSize: 48, color: '#b5a48a' }}></i>
                <h4 className="mt-2">System Settings</h4>
                <div className="card_paragraph">
                  Configure system-level parameters such as penalty rates and
                  escalation thresholds used across the platform.
                </div>
              </div>
            </div>
          </div>
          <div></div>
        </div>
      </div> */}
      <div className="container">
  <div style={{ 
    display: 'grid', 
    gridTemplateColumns: 'repeat(3, 1fr)', 
    gap: '1rem' 
  }}>
    
    <div className="card admin-cards" onClick={handleBusiness}>
      <div className="card-body text-center">
        <img className="img-fluid" src="./images/business_logo.svg" alt="true" />
        <h4 className="mt-2">Business</h4>
        <div className="card_paragraph">Business refers to an enterprising entity or organization that carries out professional activities.</div>
      </div>
    </div>

    <div className="card admin-cards" onClick={handleInvestors}>
      <div className="card-body text-center">
        <img className="img-fluid" src="./images/Investors.svg" alt="true" />
        <h4 className="mt-2">Investors</h4>
        <div className="card_paragraph">Investor is an individual that puts money into an entity such as a business for a financial return.</div>
      </div>
    </div>

    <div className="card admin-cards" onClick={handleServiceRequests}>
      <div className="card-body text-center">
        <img className="img-fluid" src="./images/service request_1.svg" alt="true" />
        <h4 className="mt-2">Service Request</h4>
        <div className="card_paragraph">Service request defined as a formal request for service from an employee, customer, or vendor.</div>
      </div>
    </div>

    <div className="card admin-cards" onClick={handleDocRepo}>
      <div className="card-body text-center">
        <img className="img-fluid" src="./images/documents.svg" alt="true" />
        <h4 className="mt-2">Documents Repository</h4>
        <div className="card_paragraph">A document repository is used to keep a business documents securely stored and organised in a centralised location.</div>
      </div>
    </div>

    <div className="card admin-cards" onClick={handleCompliance}>
      <div className="card-body text-center">
        <img className="img-fluid" src="./images/complience.svg" alt="true" />
        <h4 className="mt-2">Compliance</h4>
        <div className="card_paragraph">Compliance means that a company adheres to the applicable rules and laws. This includes both country specific laws and requirements.</div>
      </div>
    </div>

    <div className="card admin-cards" onClick={handleEkyc}>
      <div className="card-body text-center">
        <img className="img-fluid-ekyc" src="./images/ekyc.jpg" alt="true" />
        <h4 className="mt-2">eKYC</h4>
        <div className="card_paragraph">Electronic Know Your Customer - verify investor identities through document capture, biometrics and risk assessment.</div>
      </div>
    </div>

    <div className="card admin-cards" onClick={handleSettings}>
      <div className="card-body text-center">
        <i className="fa-solid fa-gear" style={{ fontSize: 48, color: '#b5a48a' }}></i>
        <h4 className="mt-2">System Settings</h4>
        <div className="card_paragraph">Configure system-level parameters such as penalty rates and escalation thresholds used across the platform.</div>
      </div>
    </div>

  </div>
</div>
    </div>
  );
};

export default AdminDashboard;
